/*
 * @Description: 地球侧边工具栏(测距和测面积还有问题，暂时先搁置，后期问雷总会不会封装)
 * @Author: JokerShaw
 * @Date: 2023-06-14 11:10:09
 * @LastEditTime: 2023-08-02 16:45:14
 * @FilePath: \yd_yg_test_project_new\src\components\GlobeTool\index.js
 */

import React, { Component, Fragment } from 'react'
import './index.css'
import { connect } from 'react-redux'
import { message } from 'antd'
import localLayer from './statics/localLayer.png'
import LocalLayerDisplayBox from './LocalLayerDisplayBox/LocalLayerDisplayBox'
import secenApplication from './statics/secenApplication.png'
import SecenApplicationBox from './SenceApplicationBox/SenceApplicationBox'
import HotSpotElevation from './HotSpotElevation/HotSpotElevation.jsx'
import downloadicon from './statics/downlandicon.png'
import latLonNet from './statics/latLonNet.png'
import siteLocation from './statics/siteLocation.png'
import dimensionSwitch from './statics/dimensionSwitch.png'
import aeraMeasure from './statics/aeraMeasure.png'
import distanceMeasure from './statics/distanceMeasure.png'
import imageryLayers from './images/imageLayer.png'
import clearLayer from './statics/clearLayer.png'
import { allStationPoints } from './data'
import { measureLine } from './publicFunction'


class GlobeTool extends Component {
  constructor(props) {
    super(props)
    this.layer = new window.Geovis.CustomDataSource("PolygonLine")
    this.activeShapePoints = []
    this.polygonAreaPositions = []
    this.activeShape = undefined
    this.handler = undefined
    this.tempShape = undefined
    this.measurePrimitive = []
    // this.hotSpotPositions=[]
    this.stateGraticule = false;//控制经纬网显隐
    this.stationMarkers = {
      show: false,
      data: []
    }
    this.dimension = "3D"//控制二三维切换
    this.slider = null
    this.state = {
      isLocalLayerToolbar: false,//本地图层按钮是否被点击
      isOnlineLayerToolbar: false,//在线图层按钮是否被点击
      isSecenApplicationToolbar: false,//场景应用按钮是否被点击
      isLatLonNetToolbar: false,//经纬网按钮是否被点击
      isSiteLocationToolbar: false,//站点定位按钮是否被点击
      isDimensionSwitchToolbar: false,//二三维切换按钮是否被点击
      isAeraMeasureToolbar: false,//面积测量按钮是否被点击
      isDistanceMeasureToolbar: false,//距离测量按钮是否被点击
      isLocalLayerDisplayBox: false,//是否显示本地图层展示框
      isSecenApplicationBox: false,//是否显示应用场景展示框
      isHotSpotElevationDownlandBox: false,//是否显示高程热点数据下载显示框
      positions: [],//多边形的顶点坐标
      showSlider: false
    }
  }



  changeToolbarStatus = async (toolbarName) => {
    switch (toolbarName) {
      case '本地图层':
        this.setState({
          isLocalLayerToolbar: !this.state.isLocalLayerToolbar,//本地图层按钮是否被点击
          isOnlineLayerToolbar: false,//在线图层按钮是否被点击
          isSecenApplicationToolbar: false,//场景应用按钮是否被点击
          // isLatLonNetToolbar: false,//经纬网按钮是否被点击 
          // isSiteLocationToolbar: false,//站点定位按钮是否被点击
          // isDimensionSwitchToolbar: false,//二三维切换按钮是否被点击
          // isAeraMeasureToolbar: false,//面积测量按钮是否被点击
          // isDistanceMeasureToolbar: false,//距离测量按钮是否被点击
          isLocalLayerDisplayBox: !this.state.isLocalLayerDisplayBox,//是否显示本地图层展示框
          isSecenApplicationBox: false,////是否显示应用场景展示框
          isHotSpotElevationDownlandBox: false,//是否显示高程热点数据显示下载框
        })
        break;
      case '热点高程下载':
        this.deletePolygonFromViewer()

        if (this.handler) {
          this.handler.removeInputAction(window.Geovis.ScreenSpaceEventType.LEFT_CLICK)
          this.handler.removeInputAction(window.Geovis.ScreenSpaceEventType.MOUSE_MOVE)
          this.handler.removeInputAction(window.Geovis.ScreenSpaceEventType.RIGHT_CLICK)
        }


        this.setState({
          isLocalLayerToolbar: false,//本地图层按钮是否被点击
          isOnlineLayerToolbar: !this.state.isOnlineLayerToolbar,//在线图层按钮是否被点击
          isSecenApplicationToolbar: false,//场景应用按钮是否被点击
          // isLatLonNetToolbar: false,//经纬网按钮是否被点击 
          // isSiteLocationToolbar: false,//站点定位按钮是否被点击
          // isDimensionSwitchToolbar: false,//二三维切换按钮是否被点击
          // isAeraMeasureToolbar: false,//面积测量按钮是否被点击
          // isDistanceMeasureToolbar: false,//距离测量按钮是否被点击
          isLocalLayerDisplayBox: false,//是否显示本地图层展示框
          isSecenApplicationBox: false,////是否显示应用场景展示框
          isHotSpotElevationDownlandBox: !this.state.isHotSpotElevationDownlandBox,//是否显示高程热点数据显示下载框
        }, () => {
          if (this.state.isHotSpotElevationDownlandBox) {
            this.addHotSpotElevationServerLayer()
            this.drawPolygonActive()
            this.addPolygonToViewer()
          } else {
            this.clearHotSpotElevationServerLayer()
            this.deletePolygonFromViewer()
          }
        })
        break;
      case '场景应用':
        this.setState({
          isLocalLayerToolbar: false,//本地图层按钮是否被点击
          isOnlineLayerToolbar: false,//在线图层按钮是否被点击
          isSecenApplicationToolbar: !this.state.isSecenApplicationToolbar,//场景应用按钮是否被点击
          // isLatLonNetToolbar: false,//经纬网按钮是否被点击
          // isSiteLocationToolbar: false,//站点定位按钮是否被点击
          // isDimensionSwitchToolbar: false,//二三维切换按钮是否被点击
          // isAeraMeasureToolbar: false,//面积测量按钮是否被点击
          // isDistanceMeasureToolbar: false,//距离测量按钮是否被点击
          isLocalLayerDisplayBox: false,//是否显示本地图层展示框
          isSecenApplicationBox: true,////是否显示应用场景展示框
          isHotSpotElevationDownlandBox: false,//是否显示高程热点数据显示下载框
        })
        this.refs.secenApp.getSensingImageSource(1)
        break;
      case '经纬网':
        this.loadGraticule()
        this.setState({
          // isLocalLayerToolbar: false,//本地图层按钮是否被点击
          // isOnlineLayerToolbar:false,//在线图层按钮是否被点击
          // isSecenApplicationToolbar: false,//场景应用按钮是否被点击
          isLatLonNetToolbar: !this.state.isLatLonNetToolbar,//经纬网按钮是否被点击
          // isSiteLocationToolbar: false,//站点定位按钮是否被点击
          // isDimensionSwitchToolbar: false,//二三维切换按钮是否被点击
          // isAeraMeasureToolbar: false,//面积测量按钮是否被点击
          // isDistanceMeasureToolbar: false,//距离测量按钮是否被点击
          // isLocalLayerDisplayBox: false,//是否显示本地图层展示框
          // isSecenApplicationBox:false,////是否显示应用场景展示框
        })

        break;
      case '站点定位':
        this.loadStationMarkers()
        this.setState({
          // isLocalLayerToolbar: false,//本地图层按钮是否被点击
          // isOnlineLayerToolbar:false,//在线图层按钮是否被点击
          // isSecenApplicationToolbar: false,//场景应用按钮是否被点击
          // isLatLonNetToolbar: false,//经纬网按钮是否被点击
          isSiteLocationToolbar: !this.state.isSiteLocationToolbar,//站点定位按钮是否被点击
          // isDimensionSwitchToolbar: false,//二三维切换按钮是否被点击
          // isAeraMeasureToolbar: false,//面积测量按钮是否被点击
          // isDistanceMeasureToolbar: false,//距离测量按钮是否被点击
          // isLocalLayerDisplayBox: false,//是否显示本地图层展示框
          // isSecenApplicationBox:false,////是否显示应用场景展示框
        })
        break;
      case '二三维切换':
        this.changeDimension()
        this.setState({
          // isLocalLayerToolbar: false,//本地图层按钮是否被点击
          // isOnlineLayerToolbar:false,//在线图层按钮是否被点击
          // isSecenApplicationToolbar: false,//场景应用按钮是否被点击
          // isLatLonNetToolbar: false,//经纬网按钮是否被点击
          // isSiteLocationToolbar: false,//站点定位按钮是否被点击
          isDimensionSwitchToolbar: !this.state.isDimensionSwitchToolbar,//二三维切换按钮是否被点击
          // isAeraMeasureToolbar: false,//面积测量按钮是否被点击
          // isDistanceMeasureToolbar: false,//距离测量按钮是否被点击
          // isLocalLayerDisplayBox: false,//是否显示本地图层展示框
          // isSecenApplicationBox:false,////是否显示应用场景展示框
        })
        break;
      case '面积测量':
        this.measurePrimitive.push(new window.Geovis.GvMeasureSpaceAreaPrimitive({
          scene: this.props.earth.scene
        }))
        this.setState({
          // isLocalLayerToolbar: false,//本地图层按钮是否被点击
          // isOnlineLayerToolbar:false,//在线图层按钮是否被点击
          // isSecenApplicationToolbar: false,//场景应用按钮是否被点击
          // isLatLonNetToolbar: false,//经纬网按钮是否被点击
          // isSiteLocationToolbar: false,//站点定位按钮是否被点击
          // isDimensionSwitchToolbar: false,//二三维切换按钮是否被点击
          isAeraMeasureToolbar: !this.state.isAeraMeasureToolbar,//面积测量按钮是否被点击
          // isDistanceMeasureToolbar: false,//距离测量按钮是否被点击
          // isLocalLayerDisplayBox: false,//是否显示本地图层展示框
          // isSecenApplicationBox:false,////是否显示应用场景展示框
        })
        break;
      case '距离测量':
        this.measurePrimitive.push(new window.Geovis.GvMeasureSpaceDistancePrimitive({
          scene: this.props.earth.scene
        }))
        this.setState({
          // isLocalLayerToolbar: false,//本地图层按钮是否被点击
          // isOnlineLayerToolbar:false,//在线图层按钮是否被点击
          // isSecenApplicationToolbar: false,//场景应用按钮是否被点击
          // isLatLonNetToolbar: false,//经纬网按钮是否被点击
          // isSiteLocationToolbar: false,//站点定位按钮是否被点击
          // isDimensionSwitchToolbar: false,//二三维切换按钮是否被点击
          // isAeraMeasureToolbar: false,//面积测量按钮是否被点击
          isDistanceMeasureToolbar: !this.state.isDistanceMeasureToolbar,//距离测量按钮是否被点击
          // isLocalLayerDisplayBox: false,//是否显示本地图层展示框
          // isSecenApplicationBox:false,////是否显示应用场景展示框
        })
        break;
      case '图层清除':
        this.clearAllScene()
        if (this.measurePrimitive.length !== 0)
          this.measurePrimitive.map((value, index) => {
            value.destroy()
          })
        this.setState({
          // isLocalLayerToolbar: false,//本地图层按钮是否被点击
          // isOnlineLayerToolbar:false,//在线图层按钮是否被点击
          // isSecenApplicationToolbar: false,//场景应用按钮是否被点击
          isLatLonNetToolbar: false,//经纬网按钮是否被点击
          isSiteLocationToolbar: false,//站点定位按钮是否被点击
          // isDimensionSwitchToolbar: false,//二三维切换按钮是否被点击
          isAeraMeasureToolbar: false,//面积测量按钮是否被点击
          isDistanceMeasureToolbar: false,//距离测量按钮是否被点击
          // isLocalLayerDisplayBox: false,//是否显示本地图层展示框
          // isSecenApplicationBox:false,////是否显示应用场景展示框
        })
        break;
      case '测试':
        const tileset = await window.Geovis.Cesium3DTileset.fromUrl(
          "http://caplos.aircas.ac.cn/tilejson/tileset.json");
        console.log('ceshi', this.props)
        this.props.earth.scene.primitives.add(tileset);
        this.props.earth.zoomTo(tileset)
        break;
      default:
        break;
    }
  }
  /**
   * @description: 加载高精度稀疏高程控制点服务图层
   * @event: 
   * @return {*}
   */
  addHotSpotElevationServerLayer = () => {
    this.props.earth.imageryLayers._layers[1].show = false
    this.hotSpotElevationServerLayer = this.props.earth.imageryLayers.addImageryProvider(
      new window.Geovis.WebMapServiceImageryProvider({
        url: 'http://124.16.188.131:9890/geoserver/day-20230728/wms',
        layers: 'day-20240401:1aa38c5f23044177b3c933ac0b63077a',
        parameters: {
          service: 'WMS',
          format: 'image/png',
          transparent: true
        },
      })
    )
  }

  clearHotSpotElevationServerLayer = () => {
    this.props.earth.scene.imageryLayers && this.props.earth.scene.imageryLayers.remove(this.hotSpotElevationServerLayer);
    this.props.earth.imageryLayers._layers[1].show = true
  }

  changeVisibleStatus = () =>
    this.setState({
      isSecenApplicationBox: false,
      isSecenApplicationToolbar: false,//场景应用按钮是否被点击
    })

  /**
   * @description: 加载经纬网
   * @event: loadGraticule
   * @return {*}
   */
  loadGraticule = () => {
    console.log('cccc', this.props.earth)
    if (!this.stateGraticule) {
      this.graticuleLayer = this.props.earth.scene.imageryLayers.addImageryProvider(
        new window.Geovis.GvGraticuleImageryProvider({
          color: window.Geovis.Color.fromCssColorString("#31e0e9")
        })
      )
    } else {
      this.props.earth.scene.imageryLayers.remove(this.graticuleLayer);
    }
    this.stateGraticule = !this.stateGraticule
  }

  /**
   * @description: 加载场站网
   * @event: 
   * @return {*}
   */
  loadStationMarkers = () => {
    if (!this.stationMarkers.show) {
      this.markers = this.props.earth.scene.primitives.add(new window.Geovis.PointPrimitiveCollection())
      allStationPoints.map(point => {
        this.markers.add({
          position: new window.Geovis.Cartesian3.fromDegrees(point[0], point[1]),
          color: window.Geovis.Color.YELLOW
        })
        this.stationMarkers.data.push(this.markers);
      })
      this.props.earth.camera.flyTo({
        destination: window.Geovis.Cartesian3.fromDegrees(116.3, 39.9, 10000000),
      })
    } else {
      this.stationMarkers.data.map(marker => {
        this.props.earth.scene.primitives.remove(marker)
      }, () => {
        this.stationMarkers.data = []
      })
    }
    this.stationMarkers.show = !this.stationMarkers.show;
  }
  /**
   * @description: 二三维切换
   * @event: changeDimension
   * @return {*}
   */
  changeDimension = () => {
    if (this.dimension == "3D") {
      this.props.earth.scene.mode = window.Geovis.SceneMode.SCENE2D;
      this.dimension = "2D";
    } else {
      this.props.earth.scene.mode = window.Geovis.SceneMode.SCENE3D;
      this.dimension = "3D";
    }
  }
  /**
   * @description: 清除所有图层
   * @event: clearAllScene
   * @return {*}
   */
  clearAllScene = () => {
    // 清除经纬网
    if (this.stateGraticule) {
      this.props.earth.scene.imageryLayers.remove(this.graticuleLayer);
      this.stateGraticule = false
    }
    // 清除场站网点
    if (this.stationMarkers.show) {
      this.stationMarkers.data.map(marker => {
        this.props.earth.scene.primitives.remove(marker)
      }, () => {
        this.stationMarkers.data = []
      })
      this.stationMarkers.show = false
    }
  }
  /**
   * @description: 
   * @event: 
   * @param {*} layer
   * @param {*} index
   * @return {*}
   */
  // addWMTSServerToEarthLayer = () => {
  //   let WMTSLayer = this.props.earth.imageryLayers.addImageryProvider(
  //     new window.Geovis.WebMapServiceImageryProvider({
  //       url: 'http://124.16.188.131:8989/geoserver/day-20230724/wms',
  //       layers: "day-20230724:trans_dem_count",
  //       parameters: {
  //         service:'WMS',
  //         format: "image/png",
  //         transparent:true
  //       } ,
  //     })
  //   )
  //   this.checkLayerList[index][1] = WMTSLayer
  // }
  /**
   * @description: 添加鼠标事件，左键点击开始绘制，右键结束绘制
   * @event: drawPolygonActive
   * @return {*}
   */
  // 添加鼠标事件
  drawPolygonActive() {
    if (!this.handler) {
      this.handler = new window.Geovis.ScreenSpaceEventHandler(this.props.earth.scene.canvas)
    } else {
      this.handler.removeInputAction(window.Geovis.ScreenSpaceEventType.LEFT_CLICK)
      this.handler.removeInputAction(window.Geovis.ScreenSpaceEventType.MOUSE_MOVE)
      this.handler.removeInputAction(window.Geovis.ScreenSpaceEventType.RIGHT_CLICK)
    }

    // 鼠标左键单击画点
    this.handler.setInputAction((event) => {
      this.deletePolygonFromViewer()
      const earthPositions = this.getPosition(this.props.earth, event.position)
      if (window.Geovis.defined(earthPositions)) {
        if (this.activeShapePoints.length === 0) {
          this.activeShapePoints.push(earthPositions)
          //   console.log("this.activeShapePoints",this.activeShapePoints
          const dynamicPositions = new window.Geovis.CallbackProperty(() => {
            return new window.Geovis.PolygonHierarchy(this.activeShapePoints)
          }, false)
          this.activeShape = this.drawPolygon(dynamicPositions)
        }
        this.activeShapePoints.push(earthPositions)
      }
    }, window.Geovis.ScreenSpaceEventType.LEFT_CLICK)

    // 鼠标移动
    this.handler.setInputAction((move) => {
      if (this.activeShapePoints.length >= 2) {
        const earthPositions = this.getPosition(this.props.earth, move.endPosition)
        if (window.Geovis.defined(earthPositions)) {
          this.activeShapePoints.pop()
          this.activeShapePoints.push(earthPositions)
        }
      }
    }, window.Geovis.ScreenSpaceEventType.MOUSE_MOVE)

    // 单击鼠标右键结束绘画
    this.handler.setInputAction((event) => {
      // console.log(this.state.selectAreaType)
      this.activeShapePoints.pop()
      this.layer.entities.remove(this.activeShape)
      // console.log(this.activeShapePoints)
      this.tempShape = this.drawPolygon(this.activeShapePoints)
      this.polygonAreaPositions = this.activeShapePoints
      this.getPloygonAreaPositions()

      this.activeShapePoints = []
      // console.log(position)
      // this.callback(position)
      // return position
    }, window.Geovis.ScreenSpaceEventType.RIGHT_CLICK)
  }
  /**
   * @description: 获取点位
   * @event: getPosition
   * @return {*}
   */
  getPosition(viewer, position) {
    let earthPositions = undefined
    // 球面
    if (viewer.terrainProvider instanceof window.Geovis.EllipsoidTerrainProvider) {
      earthPositions = viewer.scene.camera.pickEllipsoid(position)
    }
    // 地形
    else {
      const ray = viewer.camera.getPickRay(position)
      earthPositions = viewer.scene.globe.pick(ray, viewer.scene)
    }
    return earthPositions
  }

  // 绘制多边形
  drawPolygon(positionData) {
    return this.layer.entities.add({
      polygon: {
        hierarchy: positionData,
        with: 5,
        extruededHeight: 0,
        height: 0,
        material: window.Geovis.Color.BLUE.withAlpha(0.2),
        outline: true,
        outlineColor: window.Geovis.Color.fromCssColorString("#ff0000").withAlpha(1),
        outlineWidth: 2
      }
    })
  }
  // 添加图层
  addPolygonToViewer() {
    this.props.earth.dataSources.add(this.layer)
    // let position = this.getPloygonAreaPositions()
    // return position
  }
  /**
   * @description: 删除绘制的图层
   * @event: 
   * @return {*}
   */
  deletePolygonFromViewer() {
    this.layer.entities.remove(this.tempShape)
  }
  // 获取多边形的点坐标
  getPloygonAreaPositions() {
    let positions = []
    // console.log("this.polygonAreaPositions",this.polygonAreaPositions)
    this.polygonAreaPositions && this.polygonAreaPositions.map(element => {
      let cartographic = window.Geovis.Cartographic.fromCartesian(element)
      let latitude = window.Geovis.Math.toDegrees(cartographic.latitude)
      let longitude = window.Geovis.Math.toDegrees(cartographic.longitude)
      positions.push('[' + longitude + ',' + latitude + ']')
    })

    if (positions.length <= 2) {
      message.error('请至少选择三个点')
    } else {
      this.setState({
        positions: positions,
      })
    }
    return positions
  }

  setSliderShow = (flag) => {
    this.setState({
      showSlider: flag
    })
  }

  render() {
    const {
      isLocalLayerToolbar,
      isSecenApplicationToolbar,
      isLatLonNetToolbar,
      isSiteLocationToolbar,
      isDimensionSwitchToolbar,
      isAeraMeasureToolbar,
      isDistanceMeasureToolbar,
      isLocalLayerDisplayBox,
      isOnlineLayerToolbar,
      isSecenApplicationBox,
      isHotSpotElevationDownlandBox,
      positions,
      showSlider
    } = this.state

    return (
      <Fragment>
        <div className="gobleTools-side-toolbar-wrap">
          <div
            title="本地图层"
            className={isLocalLayerToolbar ? "gobleTools-side-single-toolbar-wrap-checked" : "gobleTools-side-single-toolbar-wrap"}
            onClick={() => { this.changeToolbarStatus('本地图层') }}
          >
            <img src={localLayer} className="gobleTools-side-single-toolbar-img"></img>
          </div>
          {/* <div
            title="在线图层"
            className={isOnlineLayerToolbar ? "gobleTools-side-single-toolbar-wrap-checked" : "gobleTools-side-single-toolbar-wrap"}
            onClick={() => { this.changeToolbarStatus('在线图层') }}
          >
            <img src={onlineLayers} className="gobleTools-side-single-toolbar-img"></img>
          </div> */}
          <div
            title="场景应用"
            className={isSecenApplicationToolbar ? "gobleTools-side-single-toolbar-wrap-checked" : "gobleTools-side-single-toolbar-wrap"}
            onClick={() => { this.changeToolbarStatus('场景应用') }}
          >
            <img src={secenApplication} className="gobleTools-side-single-toolbar-img"></img>
          </div>
          <div
            title="高精度稀疏高程控制点下载"
            className={isOnlineLayerToolbar ? "gobleTools-side-single-toolbar-wrap-checked" : "gobleTools-side-single-toolbar-wrap"}
            onClick={() => { this.changeToolbarStatus('热点高程下载') }}
          >
            <img src={downloadicon} className="gobleTools-side-single-toolbar-img"></img>
          </div>
          <div
            title="经纬网"
            className={isLatLonNetToolbar ? "gobleTools-side-single-toolbar-wrap-checked" : "gobleTools-side-single-toolbar-wrap"}
            onClick={() => { this.changeToolbarStatus('经纬网') }}
          >
            <img src={latLonNet} className="gobleTools-side-single-toolbar-img"></img>
          </div>
          <div
            title="站点定位"
            className={isSiteLocationToolbar ? "gobleTools-side-single-toolbar-wrap-checked" : "gobleTools-side-single-toolbar-wrap"}
            onClick={() => { this.changeToolbarStatus('站点定位') }}
          >
            <img src={siteLocation} className="gobleTools-side-single-toolbar-img"></img>
          </div>
          <div
            title="二三维切换"
            className={isDimensionSwitchToolbar ? "gobleTools-side-single-toolbar-wrap-checked" : "gobleTools-side-single-toolbar-wrap"}
            onClick={() => { this.changeToolbarStatus('二三维切换') }}
          >
            <img src={dimensionSwitch} className="gobleTools-side-single-toolbar-img"></img>
          </div>
          <div
            title="面积测量"
            className={isAeraMeasureToolbar ? "gobleTools-side-single-toolbar-wrap-checked" : "gobleTools-side-single-toolbar-wrap"}
            onClick={() => { this.changeToolbarStatus('面积测量') }}
          >
            <img src={aeraMeasure} className="gobleTools-side-single-toolbar-img"></img>
          </div>
          <div
            title="距离测量"
            className={isDistanceMeasureToolbar ? "gobleTools-side-single-toolbar-wrap-checked" : "gobleTools-side-single-toolbar-wrap"}
            onClick={() => { this.changeToolbarStatus('距离测量') }}
          >
            <img src={distanceMeasure} className="gobleTools-side-single-toolbar-img"></img>
          </div>
          <div
            title="图层清除"
            className="gobleTools-side-single-toolbar-wrap"
            onClick={() => { this.changeToolbarStatus('图层清除') }}
          >
            <img src={clearLayer} className="gobleTools-side-single-toolbar-img"></img>
          </div>
          <div
            title="三维模型加载"
            className="gobleTools-side-single-toolbar-wrap"
            onClick={() => { this.changeToolbarStatus('测试') }}
          >
            <img src={imageryLayers} className="gobleTools-side-single-toolbar-img"></img>
          </div>
        </div>
        <div className='gobleTools-slider' ref={ref => this.slider = ref} style={{ display: showSlider ? 'block' : 'none' }}></div>
        <LocalLayerDisplayBox visible={isLocalLayerDisplayBox}></LocalLayerDisplayBox>
        <SecenApplicationBox slider={this.slider} earth={this.props.earth} ref="secenApp" visible={isSecenApplicationBox} changeVisibleStatus={this.changeVisibleStatus} setSliderShow={this.setSliderShow}></SecenApplicationBox>
        <HotSpotElevation visible={isHotSpotElevationDownlandBox} selectedAreaPostions={positions}></HotSpotElevation>
      </Fragment>
    )
  }
}

const mapState = (state) => ({
  user: state.userReducer.get('user').toJS()
})

export default connect(mapState)(GlobeTool);


